export default __webpack_public_path__ + "static/gs-8-deploymodel-0df83dd4a1857c72333780239b04d7bb.webp";